import { Directive, HostBinding, Input } from '@angular/core';

/**
 * Base class for any component that renders as a cell inside an
 * `app-info-panel-section` grid. Provides the `fullWidth` input, which spans
 * the cell across every column of the parent section regardless of its
 * `columns` count (see `grid-column: 1 / -1`).
 */
@Directive()
export abstract class InfoPanelGridCell {
  /** Span every column of the parent section's grid instead of a single cell. */
  @Input({ transform: (v: boolean | string) => v === '' || v === true }) fullWidth = false;

  @HostBinding('style.grid-column') get gridColumn(): string | null {
    return this.fullWidth ? '1 / -1' : null;
  }
}
